<template>
  <div>
    <b-spinner small type="grow"></b-spinner>
    <span v-if="text" class="font-size-20">{{ text }} ...</span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>
